
<template>
  <div
    class="pt-2 pb-2 pr-2 chat-conversation-wrapper"
    :class="{
      'shadow-lg active-selected-chat': isActiveChatUser,
      closed: conversation.status == 'CLOSED',
    }"
  >
    <div class="flex pt-2 px-2">
      <!-- :src="user.profilePic" fjernet pga. FB img expiration 02/08/2023 -->
      <vs-avatar class="border-2 border-solid border-white" :src="UserAvatar"  size="42px" />

      <div class="contact__info flex-1 flex-col self-center">
        <h5 class="font-semibold">
          {{ user.firstName + " " + user.lastName }}
        </h5>
        <span v-if="venue">
          to<b>&nbsp;{{ venue.name }}</b>
        </span>
      </div>
      <div>
        <vs-chip color="green" v-if="timeSinceLastMessage == 'Just now'">
          <span class="whitespace-no-wrap">{{ timeSinceLastMessage }}</span>
        </vs-chip>
        <span v-else class="whitespace-no-wrap">{{ timeSinceLastMessage }}</span>
      </div>
    </div>

    <div class="flex px-4 pb-2 flex-col">
      <div class="flex self-start py-1 gap-1 flex-wrap">
        <vs-chip color="primary">
          <vs-avatar icon="info" class="avatar-icon-lg" /> {{ conversation.status | formatWord }}
        </vs-chip>

        <vs-chip v-for="topic in conversation.topics" :key="topic.topic" :color="topic.color">{{
          topic.topic
        }}</vs-chip>
      </div>
      <div class="two-lines text-sm">
        <span v-if="lastMessage.didSend"
          ><b>{{ venue.name }}:&nbsp;</b></span
        >{{ lastMessage.text }}
      </div>
    </div>
    <div class="flex justify-end px-2">
      <div v-if="conversation.assignee" class="text-xs">
        Assigned to {{ conversation.assignee.userDisplayName }}
      </div>
      <div v-else class="text-xs">Unassigned</div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import UserAvatar from "@/assets/images/profile-image.png";
export default {
  props: {
    conversation: { type: Object, required: true },
    user: { type: Object, required: true },
    isActiveChatUser: { type: Boolean },
    lastMessage: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      UserAvatar,
      timeSinceLastMessage: "",
    };
  },
  methods: {
    updateTimeAgo() {
      moment.locale("en", {
        relativeTime: {
          future: "in %s",
          past: "%s ago",
          s: "Just now",
          ss: "%ss",
          m: "1m",
          mm: "%dm",
          h: "1h",
          hh: "%dh",
          d: "1d",
          dd: "%dd",
          M: "1M",
          MM: "%dM",
          y: "1Y",
          yy: "%dY",
        },
      });
      this.timeSinceLastMessage = moment(this.lastMessage.timestamp).fromNow(true);
    },
  },
  computed: {
    venue() {
      return this.$store.getters["venues/venue"](this.conversation.venueId);
    },
  },
  mounted() {
    this.updateTimeAgo();
    setInterval(this.updateTimeAgo, 500);
  },
};
</script>

<style lang="scss" scoped>
.two-lines {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.chat-conversation-wrapper {
  border-right: 6px solid transparent;
  border-top: 1px solid transparent;
  border-bottom: 1px solid transparent;
  transition: all 0.2s ease-in-out;

  &.active-selected-chat {
    padding-top: 16px !important;
    padding-bottom: 16px !important;
    border-right: 6px solid;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
  }

  &.closed {
    background-color: #efefef;
  }
}
</style>
